import { render, staticRenderFns } from "./courseCompletionActivity.vue?vue&type=template&id=3c5a8832&scoped=true&"
import script from "./courseCompletionActivity.vue?vue&type=script&lang=js&"
export * from "./courseCompletionActivity.vue?vue&type=script&lang=js&"
import style0 from "./courseCompletionActivity.vue?vue&type=style&index=0&id=3c5a8832&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5a8832",
  null
  
)

export default component.exports